import restService from "../rest-service/RestService";
import { INotificationMessageModel } from "./Models";









interface INotificationMessageQueryParams {
    groupID: number
}

const NotificationMessageDataService = {

    get: async function(groupID: number, abortSignal?: AbortSignal): Promise<INotificationMessageModel[]> {

        const params: INotificationMessageQueryParams = {
            groupID: groupID
        };

        const response = await restService.get<INotificationMessageModel[], INotificationMessageQueryParams>("notifications", abortSignal, params);
        const data =  response.data;


        data.forEach(o => {
            o.messageDate = o.messageDate ? new Date(o.messageDate) : undefined;
            o.messageExpirationDate = o.messageExpirationDate ? new Date(o.messageExpirationDate) : undefined
        });


        return data;
    },
    acknowledgeMessage: async function(groupID: number, messageID: number, abortSignal?: AbortSignal): Promise<void> {

        const params: INotificationMessageQueryParams = {
            groupID: groupID
        };

        const path = `notifications/usermessage/${messageID}/acknowledge`;

        await restService.put<string, INotificationMessageQueryParams, void>(path, '', abortSignal, params);
    },
    deleteMessage: async function(groupID: number, messageID: number, requestID?: string, abortSignal?: AbortSignal): Promise<void> {

        const params: INotificationMessageQueryParams = {
            groupID: groupID
        };

        const path = requestID ?  `notifications/delete/${messageID}/${requestID}` : `notifications/delete/${messageID}`;
        await restService.delete<void, INotificationMessageQueryParams>(path, abortSignal, params);
    }

};

export default NotificationMessageDataService;


// public downloadExport(groupID: number, fileID: number): When.Promise<string> {
//     var deferred: when.Deferred<string> = when.defer<string>();

//     this._getFileURL(groupID, fileID)
//         .then((blobURI: string): any => {

//             try {
//                 Utilities.downloadFile(blobURI);
//                 deferred.resolve("Downloading");
//             } catch (error) {
//                 deferred.reject(error);
//             }
//         },
//         (reason: any) => {
//             deferred.reject(reason);
//         });

//     return deferred.promise;

// }

// private _getFileURL(groupID: number, fileID: number): When.Promise<string> {


//     var path = [
//         "filestore",
//         fileID,
//         "url"
//     ].join("/");

//     var params: Models.IRestQueryParams = {
//         contextGroupID: groupID
//     }

//     return this._restService.get<string, Models.IRestQueryParams>(path, params).then((data: Services.IRestResponse<string>) => {
//         return data.entity;
//     });
// }


// public deleteMessage(groupID: number, messageID: number, requestID?: string): When.Promise<string> {

//     var path = [
//         "notifications",
//         "delete",
//         messageID
//     ].join("/");

//     if (requestID != null) {
//         path = [
//             "notifications",
//             "delete",
//             messageID,
//             requestID
//         ].join("/");
//     }

//     var params: Models.INotificationMessageRestQueryParams = {
//         groupID: groupID
//     };

//     return this._restService.delete<string, Models.INotificationMessageRestQueryParams>(path, params).then((data: Services.IRestResponse<string>) => {
//         return data.entity;
//     });
// }
// }
